<p>user-switcher works!</p>
